import Axios from "axios";

const apiInstance = Axios.create();

apiInstance.interceptors.response.use(
  response => response,
  err => {
    if (!err.response.data.message || err.code === "ERR_BAD_RESPONSE") {
      return Promise.reject(new Error("internalError"));
    }
    return Promise.reject(new Error(err.response.data.message));
  }
);

export default apiInstance;
